import {
  WidgetContainer
} from "./chunk-BFXPDNCR.js";
import {
  getWidget
} from "./chunk-E2OTEEMV.js";

// src/renderer/index.tsx
import { cn } from "@modootoday/ui-primitives";
import { AlertCircle } from "lucide-react";
import { jsx, jsxs } from "react/jsx-runtime";
function UnsupportedWidget({
  type,
  className
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "flex items-center gap-3 rounded-xl border border-dashed border-border bg-secondary/20 px-4 py-3",
        className
      ),
      children: [
        /* @__PURE__ */ jsx(AlertCircle, { className: "size-4 shrink-0 text-muted-foreground" }),
        /* @__PURE__ */ jsxs("p", { className: "text-[12px] text-muted-foreground", children: [
          "\uC9C0\uC6D0\uD558\uC9C0 \uC54A\uB294 \uC704\uC82F \uD0C0\uC785\uC785\uB2C8\uB2E4:",
          " ",
          /* @__PURE__ */ jsx("code", { className: "rounded bg-secondary px-1 py-0.5 font-mono text-[11px]", children: type })
        ] })
      ]
    }
  );
}
function InvalidDataWidget({
  type,
  error,
  receivedKeys,
  className
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "flex items-start gap-3 rounded-sm border border-signal-danger/20 bg-signal-danger/5 px-4 py-3",
        className
      ),
      children: [
        /* @__PURE__ */ jsx(AlertCircle, { className: "mt-0.5 size-4 shrink-0 text-signal-danger" }),
        /* @__PURE__ */ jsxs("div", { className: "min-w-0 flex-1 space-y-1", children: [
          /* @__PURE__ */ jsx("p", { className: "text-[12px] font-medium text-signal-danger", children: "\uC704\uC82F \uB370\uC774\uD130 \uC624\uB958" }),
          /* @__PURE__ */ jsxs("p", { className: "font-mono text-[10px] text-signal-danger/80", children: [
            "[",
            type,
            "] ",
            error
          ] }),
          receivedKeys && receivedKeys.length > 0 && /* @__PURE__ */ jsxs("p", { className: "font-mono text-[10px] text-signal-danger/60", children: [
            "\uBC1B\uC740 \uD544\uB4DC: ",
            receivedKeys.slice(0, 8).join(", "),
            receivedKeys.length > 8 && ` (+${receivedKeys.length - 8})`
          ] })
        ] })
      ]
    }
  );
}
function WidgetRenderer({
  widget,
  onDeepLink,
  className
}) {
  const def = getWidget(widget.type);
  if (!def) {
    return /* @__PURE__ */ jsx(UnsupportedWidget, { type: widget.type, className });
  }
  const parsed = def.schema.safeParse(widget.data);
  if (!parsed.success) {
    const errorMessage = parsed.error.issues.slice(0, 2).map((issue) => `${issue.path.join(".") || "(root)"}: ${issue.message}`).join("; ");
    const receivedKeys = widget.data && typeof widget.data === "object" ? Object.keys(widget.data) : [];
    return /* @__PURE__ */ jsx(
      InvalidDataWidget,
      {
        type: widget.type,
        error: errorMessage,
        receivedKeys,
        className
      }
    );
  }
  const Component = def.component;
  const layout = widget.layout ?? def.defaultLayout;
  const chromeless = widget.type === "mcp-iframe";
  return /* @__PURE__ */ jsx(
    WidgetContainer,
    {
      title: widget.title,
      deepLink: widget.deepLink,
      onDeepLink,
      layout,
      maxHeight: chromeless ? void 0 : def.maxHeight,
      className,
      chromeless,
      children: /* @__PURE__ */ jsx(
        Component,
        {
          widget: { ...widget, data: parsed.data },
          onDeepLink
        }
      )
    }
  );
}

export {
  WidgetRenderer
};
//# sourceMappingURL=chunk-D2Q7SDLR.js.map